export default "__VITE_ASSET__Dln1mQH4__"